import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import Table from "../../components/Table/Table";
import {request} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import moment from "moment";

class DownloadRequestModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            searching: false,
            total: 0,
            page: 0,
            size: 10,
        };

        this.fetchDownloadRequests = this.fetchDownloadRequests.bind(this);
    }

    fetchDownloadRequests(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=recordId,desc';
        let params = {
            url: API_BASE_URL + '/user/downloadRequests?page=' + page + '&size=' + size + sortStr,
            method: "get",
        };
        self.setState({loading: true, searching: true});
        request(params).then(function (response) {
            console.log(response)
            self.setState({
                downloadRequests: response.data.content,
                page: page,
                size: size,
                total: response.data.totalElements,
                loading: false,
                searching: false
            })
        }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    downloadExcelFile(row) {
        let name = row.documentType;

        let params = {
            url: API_BASE_URL + '/user/downloadExcelFile',
            responseType: 'arraybuffer',
            method: "post",
            data: row.uuid
        };

        request(params).then(function (response) {
            console.log(response);
            let blob = new Blob([response.data], {type: response.headers["content-type"]});
            let urlCreator = window.URL || window.webkitURL;
            let url = urlCreator.createObjectURL(blob);
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = name + ".xlsx";
            a.click();

        }).catch(function (error) {
            if (error.response === undefined) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
            } else {
                let enc = new TextDecoder("utf-8");
                showAxiosError({message: enc.decode(error.response.data)});
            }
        });
    }

    render() {

        const columns = [
            {
                Header: "Bekleyen Döküman",
                accessor: "documentType",
                sortable: false,
            },
            {
                Header: "Başlama Tarihi",
                accessor: "createdAt",
                Cell: item => (
                    <div>
                        {item.createdAt ? moment(item.createdAt.toString().replace("T", " ")).format("DD-MM-YYYY HH:mm:ss") : "-"}
                    </div>)
            },
            {
                Header: "Bitiş Tarihi",
                accessor: 'completedAt',
                Cell: item => (<div>
                    {item.completedAt ? moment(item.completedAt.toString().replace("T", " ")).format("DD-MM-YYYY HH:mm:ss") : "-"}
                </div>)

            },
            {
                Header: "Durum",
                accessor: '',
                sortable: false,
                Cell: row => (
                    <label>{row.state === 1 ? 'Belge Hazırlanıyor' :
                        (row.state === 2 ? 'Belge İndirilebilir' :
                            (row.state === 3 ? 'Belge İndirilebilir / (Daha önce indirildi)' : ''))}</label>
                )
            },
            {
                Header: "İşlemler",
                accessor: '',
                sortable: false,
                Cell: row => (
                    <div>
                        {(row.state === 2 || row.state === 3) &&
                        <button type="button"
                                data-toggle="tooltip" data-placement="bottom" title="İndir"
                                style={{background: 'rgba(70, 255, 150, 1), rgb(22, 224, 38))'}}
                                rel="tooltip" className="Btn btn-icon" onClick={() => this.downloadExcelFile(row)}>
                            <i className="BtnIcon fa fa-download"/>
                        </button>}
                    </div>
                )
            }
        ];

        return (
            <Modal isOpen={this.props.isOpen} size='xl'>
                <ModalHeader toggle={this.props.close}>Bekleyen İndirmeleriniz</ModalHeader>
                <ModalBody>
                    <Table
                        columns={columns}
                        content={this.state.downloadRequests ? this.state.downloadRequests : []}
                        total={this.state.total}
                        page={this.state.page}
                        size={this.state.size}
                        loading={this.state.loading}
                        options={['5', '10', '20']}
                        fetchData={this.fetchDownloadRequests}/>
                </ModalBody>
            </Modal>
        )
    }
}

export default DownloadRequestModal;


// WEBPACK FOOTER //
// ./src/components/Table/DownloadRequestModal.js